export const withProps = (Comp: any, addOn?: any): React.FunctionComponent => 
    (sprops: any) => {
        return <Comp {...sprops} {...addOn} />
    }